import { Title } from '../../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Documentação</Title>

                    <section className="mt-2 p-3">

                        <p>
                            Axial e coronal mediastino utilizar ww 350 e wl 40
                            <br/>
                            Axial e coronal pulmão utilizar ww 1.200 e wl -700;
                        </p>
                        <p>
                            <b>Axial Mediastino</b> - 1 filme na formatação de 24 imagens;<br/>
                            <b>Coronal Mediastino</b> - 1 filme na formatação de 20 imagens;<br/>
                            <b>Axial Pulmão</b> - 3 filmes na formatação de 12 imagens;<br/>
                            <b>Coronal Pulmão</b> - 1 filme na formatação de 20 imagens; <br/>
                        </p>

                        <p>
                            <b>Impressão Mista, Filme e Papel</b><br/>
                            Axial em filme; <br/>
                            Coronal papel;<br/>
                            3D Pulmões em Papel;<br/>
                        </p>
                        <p>
                            <b>Impressão apenas em Papel</b><br/>
                            Axial em papel;<br/>
                            Coronal em papel;<br/>
                            3D Pulmões em papel;<br/>
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}